/**
 * CategoryBadge – Small colored tag indicating the category of a settlement step.
 * Figma-matched: uses brand teal/blue background with white text.
 */

import { SETTLEMENT_PLANNER_STEP_CARD } from './settlementTheme';

const CATEGORY_STYLES: Record<string, { bg: string; text: string }> = {
  'Secure Property':                 { bg: 'bg-blue-600',  text: 'text-white-alt' },
  'Personal & Final Arrangements':   { bg: 'bg-blue-600',  text: 'text-white-alt' },
  'Find Legal Documents':            { bg: 'bg-blue-600',  text: 'text-white-alt' },
  'Financial Accounts':              { bg: 'bg-green-600', text: 'text-white-alt' },
  'Legal & Probate':                 { bg: 'bg-blue-900',  text: 'text-white-alt' },
  'Notifications':                   { bg: 'bg-orange-600', text: 'text-white-alt' },
  'Debts & Taxes':                   { bg: 'bg-orange-900', text: 'text-white-alt' },
  'Distribution':                    { bg: 'bg-green-900', text: 'text-white-alt' },
  'Closing':                         { bg: 'bg-grey-600',  text: 'text-white-alt' },
};

const DEFAULT_STYLE = { bg: 'bg-blue-300', text: 'text-white-alt' };

interface CategoryBadgeProps {
  category: string;
  className?: string;
  appearance?: 'default' | 'planner';
}

export default function CategoryBadge({ category, className = '', appearance = 'default' }: CategoryBadgeProps) {
  const style = CATEGORY_STYLES[category] || DEFAULT_STYLE;
  const defaultClassName = `px-3 py-0.5 rounded-md text-xs font-medium ${style.bg} ${style.text}`;

  return (
    <span
      className={`inline-block whitespace-nowrap ${appearance === 'planner' ? SETTLEMENT_PLANNER_STEP_CARD.badge : defaultClassName} ${className}`}
    >
      {category}
    </span>
  );
}
